<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <div>
          <v-select
            :items="ev_model_list"
            item-text="ModelName"
            item-value="EVModelID"
            :label="select_model"
            @change="change_model"
            dense
          ></v-select>
        </div>
      </v-col>
      <v-col cols="4">
        <div>
          <v-select
            v-model="daytype"
            :items="daytype_list"
            :label="select_day_type"
            @change="change_daytype"
            :hint="`${$t('components.EVModelEditDetails.labels.mostRecentWeekdayTooltip')}`"
            persistent-hint
            dense
          ></v-select>
        </div>
      </v-col>
      <v-col cols="4">
        <div>
          <v-checkbox v-model="use_commuter" :label="use_commuter_status" @change="calculate_ev_chart"></v-checkbox>
        </div>
      </v-col>
      <v-col col="12"> </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="text-h6">
          {{ $t("components.EVModelEditDetails.labels.evModelDetails") }}
        </div>
        <div class="primaryGrey--text" style="margin-bottom: 20px">
          Model Name : {{ ev_model.ModelName }} ("{{ ev_model.ModelShortName }}")

          <v-btn
            small
            v-if="edit_mode == false"
            color="primary"
            dense
            class="bold"
            @click="set_edit_mode(true)"
            style="margin-left: 15px"
          >
            <v-icon small left> mdi-pencil </v-icon>
            {{ $t("common.words.edit") }}
          </v-btn>
          <v-btn small v-if="edit_mode == true" dense outlined class="ml-4 mr-2 bold" @click="set_edit_mode(false)">
            {{ $t("common.words.cancel") }}
          </v-btn>
          <v-btn
            small
            v-if="edit_mode == true && ev_model.Editable == 1"
            dense
            color="primary"
            @click="save_model()"
            class="bold"
            style="margin-right: 10px"
          >
            {{ $t("common.words.save") }}
          </v-btn>
          <v-dialog v-model="saveas_dialog" v-if="edit_mode == true" width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small color="primary" dark v-bind="attrs" v-on="on">
                {{ $t("common.words.saveAs") }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t("components.EVModelEditDetails.labels.chooseModelName") }}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field :label="model_name" v-model="new_model_name" required></v-text-field>
                  </v-col>
                </v-row>
                <small>*{{ $t("common.labels.indicatesRequiredField") }}</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="saveas_dialog = false">
                  {{ $t("common.words.cancel") }}
                </v-btn>
                <v-btn color="blue darken-1" text @click="saveas_model()">
                  {{ $t("common.words.save") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-col>
    </v-row>
    <v-spacer></v-spacer>
    <v-row>
      <v-col key="edit_col" cols="4" style="border-right: 3px dashed #b3e5fc" v-show="edit_mode == true">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="6">
              <v-text-field
                color="primaryDark"
                dense
                style="width: 200px"
                v-model="ev_model.ChargePerWeekday"
                @change="calculate_ev_chart"
                :label="charge_rate_weekday"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                color="primaryDark"
                dense
                style="width: 200px"
                v-model="ev_model.ChargePerWeekendDay"
                @change="calculate_ev_chart"
                :label="charge_rate_weekend"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-card flat color="transparent">
                <v-subheader>{{ $t("components.EVModelEditDetails.labels.chargeDurationWeekday") }}</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-slider
                        v-model="ev_model.ChargeDurationWeekday"
                        class="align-center"
                        max="12"
                        min="0"
                        step="0.1"
                        thumb-label="always"
                        hide-details
                        @mouseup="calculate_ev_chart"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="ev_model.ChargeDurationWeekday"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-card flat color="transparent">
                <v-subheader>{{ $t("components.EVModelEditDetails.labels.chargeDurationWeekend") }}</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-slider
                        v-model="ev_model.ChargeDurationWeekend"
                        class="align-center"
                        max="12"
                        min="0"
                        step="0.1"
                        thumb-label="always"
                        hide-details
                        @mouseup="calculate_ev_chart"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="ev_model.ChargeDurationWeekend"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-card flat color="transparent">
                <v-subheader
                  >{{ $t("components.EVModelEditDetails.labels.ratioOfHigh1") }}
                  {{ this.per_ev_power }}
                  {{ $t("components.EVModelEditDetails.labels.ratioOfHigh2") }}</v-subheader
                >

                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-slider
                        v-model="high_power_chargers_ratio"
                        track-color="orange darken-3"
                        max="100"
                        min="0"
                        step="1"
                        thumb-label="always"
                        @mouseup="calculate_ev_chart"
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            :value="high_power_chargers_ratio"
                            class="mt-0 pt-0"
                            label="7Kw"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            :value="inverse_highpower"
                            class="mt-0 pt-0"
                            label="3Kw"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-card flat color="transparent">
                <v-subheader>{{ $t("components.EVModelEditDetails.labels.ratioOfBEV") }}</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col class="pr-4">
                      <v-slider
                        v-model="bev_ratio"
                        track-color="orange darken-3"
                        max="100"
                        min="0"
                        step="1"
                        thumb-label="always"
                        @mouseup="calculate_ev_chart"
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            :value="bev_ratio"
                            class="mt-0 pt-0"
                            label="BEV"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            :value="inverse_bevratio"
                            class="mt-0 pt-0"
                            label="PHEV"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <!-- <v-col cols="4" class="d-flex justify-center">
              <v-radio-group
                v-model="ev_model.AnalysisMethod"
                @change="calculate_ev_chart"
                row
              >
                <template v-slot:label>
                  <div>Statistical analysis method:</div>
                </template>
                <v-radio
                  label="Basic"
                  value="basic"
                ></v-radio>
                <v-radio
                  label="Binomial"
                  value="binomial"
                ></v-radio>
              </v-radio-group>
            </v-col> -->
            <v-col>
              <v-card flat color="transparent">
                <v-subheader>{{ $t("components.EVModelEditDetails.labels.confidenceLevel") }}</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-slider
                        v-model="confidence_binomial"
                        max="100"
                        min="0"
                        step="1"
                        thumb-label="always"
                        @mouseup="calculate_ev_chart"
                      >
                        <template v-slot:append>
                          <v-text-field
                            :value="confidence_binomial"
                            class="mt-0 pt-0"
                            label="Confidence"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-card flat color="transparent">
                <v-subheader>{{
                  $t("components.EVModelEditDetails.labels.percentageOfPeopleWhoPurchase")
                }}</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-slider v-model="perc_new_car_buyer" max="100" min="0" step="1" thumb-label="always">
                        <template v-slot:append>
                          <v-text-field
                            :value="perc_new_car_buyer"
                            class="mt-0 pt-0"
                            label="Probability"
                            type="number"
                            style="width: 60px"
                            readonly
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <AreaChartVT
                :chartData="PedictedEVSalesData"
                :ylabel="ev_forecast_chart.yAxis"
                :xlabel="ev_forecast_chart.xAxis"
                :colors="ev_forecast_chart.colors"
                :vAxes="ev_forecast_chart.vAxes"
                :series="ev_forecast_chart.series"
                :hAxis="ev_forecast_chart.hAxis"
                :chart_title="predicted_proportion"
                lineWidth="1"
                pointSize="1"
                dataOpacity="1"
              ></AreaChartVT>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col key="display_col" :cols="display_cols">
        <v-row no-gutters>
          <v-col class="text-right" style="margin-bottom: 20px">
            <v-dialog v-model="probability_dialog" scrollable max-width="600px" v-if="edit_mode == true">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  {{ $t("components.EVModelEditDetails.labels.modifyProbalities") }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>{{
                  $t("components.EVModelEditDetails.labels.changeProbabilityDistribution")
                }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 600px">
                  <v-data-table :headers="power_table_headers" :items="power_perc_table">
                    <template v-slot:item.standard="props">
                      <v-edit-dialog :return-value.sync="props.item.standard" large persistent>
                        <div>{{ props.item.standard }}</div>
                        <template v-slot:input>
                          <div class="mt-4 text-h6">Update standard</div>
                          <v-text-field
                            v-model="props.item.standard"
                            :rules="[number_rule_powerperc]"
                            label="Edit"
                            single-line
                            counter
                            autofocus
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>
                    <template v-slot:item.commuter="props">
                      <v-edit-dialog :return-value.sync="props.item.commuter" large persistent>
                        <div>{{ props.item.commuter }}</div>
                        <template v-slot:input>
                          <div class="mt-4 text-h6">Update commuter</div>
                          <v-text-field
                            v-model="props.item.commuter"
                            :rules="[number_rule_powerperc]"
                            label="Edit"
                            single-line
                            counter
                            autofocus
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>

                    <template v-slot:item.non_commuter="props">
                      <v-edit-dialog :return-value.sync="props.item.non_commuter" large persistent>
                        <div>{{ props.item.non_commuter }}</div>
                        <template v-slot:input>
                          <div class="mt-4 text-h6">Update non commuter</div>
                          <v-text-field
                            v-model="props.item.non_commuter"
                            :rules="[number_rule_powerperc]"
                            label="Edit"
                            single-line
                            counter
                            autofocus
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>
                    <template slot="body.append">
                      <tr>
                        <th>Total</th>
                        <th
                          :class="{
                            valid_total: sum_field('standard') == 100,
                            invalid_total: sum_field('standard') != 100,
                          }"
                        >
                          {{ sum_field("standard") }}
                        </th>
                        <th
                          :class="{
                            valid_total: sum_field('commuter') == 100,
                            invalid_total: sum_field('commuter') != 100,
                          }"
                        >
                          {{ sum_field("commuter") }}
                        </th>
                        <th
                          :class="{
                            valid_total: sum_field('non_commuter') == 100,
                            invalid_total: sum_field('non_commuter') != 100,
                          }"
                        >
                          {{ sum_field("non_commuter") }}
                        </th>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="probability_dialog = false"> Close </v-btn>
                  <v-btn color="blue darken-1" text @click="save_probabilities()"> Save </v-btn>
                </v-card-actions>
              </v-card>
              <v-snackbar color="red accent-2" v-model="error_snackbar">
                {{ error_text }}

                <template v-slot:action="{ attrs }">
                  <v-btn color="white" text v-bind="attrs" @click="error_snackbar = false"> Close </v-btn>
                </template>
              </v-snackbar>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card flat>
              <v-card-text class="pa-0">
                <AreaChartVT
                  v-if="cumul_prob_chart.data"
                  :chartData="cumul_prob_chart.data"
                  :ylabel="cumul_prob_chart.yAxis"
                  :xlabel="cumul_prob_chart.xAxis"
                  :colors="cumul_prob_chart.colors"
                  :vAxes="cumul_prob_chart.vAxes"
                  :series="cumul_prob_chart.series"
                  :chart_title="probability_ev_charger"
                  lineWidth="1"
                  pointSize="1"
                  dataOpacity="1"
                ></AreaChartVT>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card flat>
              <v-card-text class="pa-0">
                <AreaChartVT
                  v-if="power_load_data_only"
                  :chartData="power_load_data_only"
                  :ylabel="power_model_chart.yAxis"
                  :xlabel="power_model_chart.xAxis"
                  :colors="power_model_chart.colors"
                  :vAxes="power_model_chart.vAxes"
                  :series="power_model_chart.series"
                  :chart_title="power_load_chart_title"
                  lineWidth="1"
                  pointSize="1"
                  dataOpacity="1"
                ></AreaChartVT>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card flat>
              <v-card-text class="pa-0">
                <AreaChartVT
                  v-if="ev_model_chart && ev_model_chart.data"
                  :chartData="ev_model_chart.data"
                  :ylabel="ev_model_chart.yAxis"
                  :xlabel="ev_model_chart.xAxis"
                  :colors="ev_model_chart.colors"
                  :vAxes="ev_model_chart.vAxes"
                  :series="ev_model_chart.series"
                  :chart_title="ev_model_chart_title"
                  lineWidth="1"
                  pointSize="1"
                  dataOpacity="1"
                ></AreaChartVT>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card flat>
              <v-card-text class="pa-0">
                <ColumnChartVT
                  :chartData="ev_calculated_sales"
                  :ylabel="ev_calculated_sales_chart.yAxis"
                  :xlabel="ev_calculated_sales_chart.xAxis"
                  :hAxis="ev_calculated_sales_chart.hAxis"
                  :chart_title="ev_calculated_sales_chart_title"
                  lineWidth="1"
                  pointSize="1"
                  dataOpacity="1"
                >
                </ColumnChartVT>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AreaChartVT from "../components/AreaChartVT";
import ColumnChartVT from "../components/ColumnChartVT";
import axios from "axios";
import moment from "moment";
import { i18n } from "../plugins/i18n";

var cdf = require("binomial-cdf");

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
const api_root = process.env["VUE_APP_ROOT_API"];
const HIGH_POWER_EV_KV = 7.0;
const LOW_POWER_EV_KV = 3.0;
const BEV_POWER_RATIO = 0.5;

export default {
  name: "EVModelEditDetails",
  props: {
    device_id: String,
    device_data: Object,
  },
  components: {
    AreaChartVT,
    ColumnChartVT,
  },
  data: function () {
    return {
      ev_calculated_sales_chart_title: this.$t("components.EVModelEditDetails.charts.totalNewEVCharge.title"),
      ev_model_chart_title: this.$t("components.EVModelEditDetails.charts.evModelChart.title"),
      probability_ev_charger: this.$t("components.EVModelEditDetails.charts.cumulProbChart.title"),
      predicted_proportion: this.$t("components.EVModelEditDetails.charts.evForecast.title"),
      charge_rate_weekday: this.$t("components.EVModelEditDetails.labels.chargeRateWeekday"),
      charge_rate_weekend: this.$t("components.EVModelEditDetails.labels.chargeRateWeekend"),
      model_name: this.$t("components.EVModelEditDetails.labels.modelName"),
      select_model: this.$t("components.EVModelEditDetails.labels.selectModel"),
      select_day_type: this.$t("components.EVModelEditDetails.labels.selectDayType"),
      use_commuter_status: this.$t("components.EVModelEditDetails.labels.useCommuterStatus"),

      error_snackbar: false,
      error_text: "",
      valid: true,
      use_commuter: false,
      probability_dialog: false,
      new_model_name: "",
      saveas_dialog: false,
      power_perc_table: [],
      number_rule_powerperc: (v) => {
        if (typeof v === "string" && !v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 100) return true;
        return this.$t("common.labels.numberHasToBeBetween0And100");
      },
      power_table_headers: [
        {
          text: this.$t("common.labels.timeOfDay"),
          align: "start",
          sortable: false,
          value: "time_of_day",
        },
        { text: this.$t("common.words.standard") + " (%)", value: "standard" },
        { text: this.$t("common.words.commuter") + " (%)", value: "commuter" },
        {
          text: this.$t("common.words.nonCommuter") + " (%)",
          value: "non_commuter",
        },
      ],
      daytype_list: [
        this.$t("components.EVModelEditDetails.labels.mostRecentWeekday"),
        this.$t("components.EVModelEditDetails.labels.maxAnnualLoadDay"),
      ], //mostRecentWeekday
      daytype: "Most recent Weekday",
      edit_mode: false,
      ev_base_data: [],
      maxAndRequiredRule: [
        (v) => !!v || this.$t("common.labels.thisFieldIsRequired"),
        (v) => (v && v.length <= 50) || this.$t("common.labels.mustBeLessThan50Characters"),
      ],
      requiredRule: [(v) => !!v || this.$t("common.labels.thisFieldIsRequired")],
      cumul_prob: [],
      ev_model_list: [],
      load_profile_date: new Date(),
      ev_model: {},
      PedictedEVSalesData: [
        [this.$t("common.times.time.year"), "EV Sales (%)"],
        [2024, 19],
        [2025, 23],
        [2026, 28],
        [2027, 35],
        [2028, 40],
        [2029, 48],
        [2030, 58],
        [2031, 73],
        [2032, 88],
      ],
      ev_model_data: {
        HourOfDay: [],
        PowerUsed: [],
        Headroom: [],
        PluginStartPerc: [],
        PluginStartPercCommuter: [],
        PluginStartPercNonCommuter: [],
      },
      ev_predicted: [],
      ev_max_predicted: 0,
      power_model_chart: {
        id: "power_model_chartdata",
        label: this.$t("components.EVModelEditDetails.charts.powerLoadDataOnly.label"),
        seriesType: "lines",
        xAxis: this.$t("components.EVModelEditDetails.charts.powerLoadDataOnly.xLabel"),
        yAxis: this.$t("components.EVModelEditDetails.charts.powerLoadDataOnly.yLabel"),
        colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],

        data: [["Timestamp", "Load (kVa)"]],
        vAxes: {
          0: {
            title: this.$t("components.EVModelEditDetails.charts.powerLoadDataOnly.vAxes.0.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: this.device_data["PowerRating"],
            },
          },
          1: {
            title: this.$t("components.EVModelEditDetails.charts.powerLoadDataOnly.vAxes.1.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: this.device_data["PowerRating"],
            },
            baseline: this.device_data["PowerRating"],
          },
        },
        series: {
          1: {
            targetAxisIndex: 1,
            annotations: {
              textStyle: {
                color: "#000",
              },
            },
          },
        },
      },
      ev_forecast_chart: {
        id: "ev_forecast_chart",
        label: this.$t("components.EVModelEditDetails.charts.evForecast.label"),
        seriesType: "lines",
        xAxis: this.$t("components.EVModelEditDetails.charts.evForecast.xAxis"),
        yAxis: this.$t("components.EVModelEditDetails.charts.evForecast.yAxis"),
        colors: ["#52a0d2", "#ff0000", "#a1c7e2", "#e4592c", "#1b428b"],
        data: [],
        vAxes: {
          0: {
            title: this.$t("components.EVModelEditDetails.charts.evForecast.vAxes.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 100,
            },
          },
        },
        series: {
          1: {
            type: "line",
            enableInteractivity: false,
            pointsVisible: false,
            annotations: {
              textStyle: {
                color: "#000",
              },
            },
          },
        },
        hAxis: {
          title: this.$t("components.EVModelEditDetails.charts.evForecast.hAxis.title"),
          textStyle: { color: "#a1c7e2", fontSize: 9 },
          viewWindowMode: "maximized",
          format: "",
        },
      },
      ev_calculated_sales_chart: {
        id: "ev_calculated_sales_chart",
        label: this.$t("components.EVModelEditDetails.charts.totalNewEVCharge.label"),
        seriesType: "lines",
        xAxis: this.$t("components.EVModelEditDetails.charts.totalNewEVCharge.xAxis"),
        yAxis: this.$t("components.EVModelEditDetails.charts.totalNewEVCharge.yAxis"),
        colors: ["#52a0d2", "#ff0000", "#a1c7e2", "#e4592c", "#1b428b"],

        vAxes: {
          0: {
            title: this.$t("components.EVModelEditDetails.charts.totalNewEVCharge.vAxes.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
          },
        },
        hAxis: {
          title: this.$t("components.EVModelEditDetails.charts.totalNewEVCharge.hAxis.title"),
          textStyle: { color: "#a1c7e2", fontSize: 9 },
          viewWindowMode: "maximized",
          format: "",
        },
        series: {
          1: {
            type: "line",
            enableInteractivity: false,
            pointsVisible: false,
            annotations: {
              textStyle: {
                color: "#ff0000",
              },
            },
          },
        },
      },
      ev_model_chart: {
        id: "ev_model_chartdata",
        label: this.$t("components.EVModelEditDetails.charts.evModelChart.label"),
        seriesType: "lines",
        xAxis: this.$t("components.EVModelEditDetails.charts.evModelChart.xAxis"),
        yAxis: this.$t("components.EVModelEditDetails.charts.evModelChart.yAxis"),
        colors: ["#52a0d2", "#ff0000", "#a1c7e2", "#e4592c", "#1b428b"],
        data: [],
        vAxes: {
          0: {
            title: this.$t("components.EVModelEditDetails.charts.evModelChart.vAxes.0.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 500,
            },
          },
          1: {
            title: this.$t("components.EVModelEditDetails.charts.evModelChart.vAxes.1.title") + this.ev_max_predicted,
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 500,
            },
          },
        },
        series: {
          1: {
            type: "line",
            enableInteractivity: false,
            pointsVisible: false,
            annotations: {
              textStyle: {
                color: "#000",
              },
            },
          },
        },
      },
      cumul_prob_chart: {
        id: "ev_model_chartdata",
        label: this.$t("components.EVModelEditDetails.charts.cumulProbChart.label"),
        seriesType: "lines",
        xAxis: this.$t("components.EVModelEditDetails.charts.cumulProbChart.xAxis"),
        yAxis: this.$t("components.EVModelEditDetails.charts.cumulProbChart.yAxis"),
        colors: ["#52a0d2", "#ff0000", "#a1c7e2", "#e4592c", "#1b428b"],
        data: [],
        vAxes: {
          0: {
            title: this.$t("components.EVModelEditDetails.charts.cumulProbChart.vAxes.title"),
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
              max: 100,
            },
          },
        },
        series: {
          1: {
            type: "line",
            enableInteractivity: false,
            pointsVisible: false,
          },
        },
      },
    };
  },
  mounted: async function () {
    await this.get_ev_models();
    await this.get_device_evbasedata();
    this.calculate_ev_chart();
  },

  methods: {
    sum_field(key) {
      // sum data in give key (property)
      return Math.round(this.power_perc_table.reduce((a, b) => a + (parseFloat(b[key]) || 0), 0) * 100) / 100;
    },
    save_probabilities() {
      //check if all totals = 100:
      var valid = true;
      if (this.sum_field("standard") != 100) {
        valid = false;
      }
      if (this.sum_field("commuter") != 100) {
        valid = false;
      }
      if (this.sum_field("non_commuter") != 100) {
        valid = false;
      }
      if (valid) {
        this.probability_dialog = false;
        this.save_ev_model_plugin_probabilities().then(() => {
          this.get_device_evbasedata().then(() => {
            this.calculate_ev_chart();
          });
        });
      } else {
        this.error_snackbar = true;
        this.error_text = "All totals must equal 100%";
      }
    },
    setEditMode: function () {
      this.edit_mode = true;
    },
    change_daytype: async function () {
      await this.get_device_evbasedata();
      this.calculate_ev_chart();
    },
    save_model: function (is_save_as) {
      if (is_save_as) {
        // create new model with name
        this.ev_model.ModelName = this.new_model_name;
        this.create_ev_model_db();
      } else {
        // save model
        this.save_ev_model_db();
      }
      this.set_edit_mode(false);
    },
    saveas_model: function () {
      this.saveas_dialog = false;
      this.save_model(true);
    },
    change_model: function (model_id) {
      for (var i = 0; i < this.ev_model_list.length; i++) {
        if (this.ev_model_list[i].EVModelID == model_id) {
          this.ev_model = this.ev_model_list[i];

          this.calculate_ev_chart();
          break;
        }
      }
    },
    maxRule: function (characters, isRequired) {
      return isRequired
        ? [
            (v) => !!v || "This field is required",
            (v) => (v && v.length <= characters) || `Must be less than ${characters} characters`,
          ]
        : [(v) => !v || (v && v.length <= characters) || `Must be less than ${characters} characters`];
    },

    numberRule: function (digits, isRequired) {
      if (typeof digits == "number") {
        return isRequired
          ? [(v) => !!v || "This field is required", (v) => (v && v <= digits) || `Must be less than ${digits}`]
          : [(v) => !v || (v && v <= digits) || `Must be less than ${digits}`];
      } else {
        return isRequired
          ? [
              (v) => !!v || "This field is required",
              (v) =>
                (v && v <= digits[1] && v >= digits[0]) ||
                `Must be less than ${digits[1]} and greater than ${digits[0]}`,
            ]
          : [(v) => !v || (v && v <= digits[1] && v >= digits[0]) || `Must be less than ${digits}`];
      }
    },
    validate: function (event, obj) {
      if (this.$refs.form.validate()) {
        this.$emit(event, obj);
      }
    },
    set_edit_mode: function (new_state) {
      this.edit_mode = new_state;
      window.dispatchEvent(new Event("resize"));
    },
    async get_device_evbasedata() {
      this.network_error = false;
      var self = this;

      const tenant = (this.$auth && this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      const accessToken = await this.$auth.getTokenSilently();
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };

      var daytype_db = "0";
      if (this.daytype == "Max Annual Load Day") {
        daytype_db = "1";
      }

      if (tenant) {
        return new Promise((resolve, reject) => {
          axios
            .get(api_root + "/api/powerdata/evbasedata/device/" + self.device_id + "?daytype=" + daytype_db, header)
            .then((response) => {
              self.ev_base_data = response.data;
              resolve(response);
            })
            .catch((e) => {
              console.log(e);
              reject(e);
            });
        });
      }
    },
    async get_ev_models() {
      this.network_error = false;
      var self = this;
      const tenant = (this.$auth && this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      const accessToken = await this.$auth.getTokenSilently();
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      if (tenant) {
        return new Promise((resolve, reject) => {
          axios
            .get(api_root + "/api/powerdata/evmodellist", header)
            .then((response) => {
              self.ev_model_list = response.data;
              self.ev_model = self.ev_model_list[0];

              resolve(response);
            })
            .catch((e) => {
              console.log(e);
              reject(e);
            });
        });
      }
    },
    async save_ev_model_db() {
      this.network_error = false;
      var self = this;

      const accessToken = await this.$auth.getTokenSilently();
      const tenant = (this.$auth && this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      if (tenant) {
        return new Promise((resolve, reject) => {
          axios
            .put(api_root + "/api/powerdata/evmodellist/" + self.ev_model.EVModelID, self.ev_model, header)
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {
              console.log(e);
              reject(e);
            });
        });
      }
    },
    async save_ev_model_plugin_probabilities() {
      this.network_error = false;
      var self = this;

      const tenant = (this.$auth && this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      const accessToken = await this.$auth.getTokenSilently();
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      if (tenant) {
        return new Promise((resolve, reject) => {
          axios
            .put(
              api_root + "/api/powerdata/evmodel_plugin_probabilities/" + self.ev_model.EVModelID,
              self.power_perc_table,
              header
            )
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {
              console.log(e);
              reject(e);
            });
        });
      }
    },
    async create_ev_model_db() {
      this.network_error = false;
      const tenant = (this.$auth && this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      const accessToken = await this.$auth.getTokenSilently();
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      if (tenant) {
        return new Promise((resolve, reject) => {
          axios
            .post(api_root + "/api/powerdata/evmodellist", this.ev_model, header)
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {
              console.log(e);
              reject(e);
            });
        });
      }
    },
    calculate_binomial: function (confidence, probility_evused, max_allowable) {
      // binomial disribution, need to find n
      var p = probility_evused;
      var k = max_allowable;
      var res = 0;
      var i = 0;
      for (i = k; i < 10 * k; i++) {
        res = 1 - cdf(k, i, p);
        if (res > confidence) {
          break;
        }
      }
      return i - 1;
    },

    add_hours: function (d, h) {
      return d.setHours(d.getHours() + h);
    },

    calculate_ev_chart: function () {
      //loop through the powerperc to get the cumulative based on inputs
      var power_percs = this.ev_model_data["PluginStartPerc"];
      //var time_of_day = new Date('01 Jan 1970 00:00:00 GMT');
      if (this.use_commuter) {
        if (this.device_data["IsCommuterArea"]) {
          power_percs = this.ev_model_data["PluginStartPercCommuter"];
        } else {
          power_percs = this.ev_model_data["PluginStartPercNonCommuter"];
        }
      }
      // create power perc table for editing:
      this.power_perc_table = [];
      for (var i = 0; i < power_percs.length; i++) {
        //time_of_day = this.add_hours(time_of_day, i);
        //time_of_day.setHours(time_of_day.getHours() + i);
        var am_pm = "AM";
        if (i > 11) {
          am_pm = "PM";
        }
        var pre = "";
        if (i < 10) {
          pre = "0";
        }
        var hour_string = `${pre}${i}:00${am_pm}`;
        this.power_perc_table.push({
          time_of_day: hour_string,
          standard: this.ev_model_data["PluginStartPerc"][i],
          commuter: this.ev_model_data["PluginStartPercCommuter"][i],
          non_commuter: this.ev_model_data["PluginStartPercCommuter"][i],
        });
      }
      var isWeekend = this.daytype == "Weekend";
      var charge_duration;
      if (isWeekend) {
        charge_duration = Math.round((this.ev_model.ChargeDurationWeekend * 10) / 10);
      } else {
        charge_duration = Math.round((this.ev_model.ChargeDurationWeekday * 10) / 10);
      }
      this.cumul_prob = [];
      var i = 0;
      var cumul_predicted = [
        [
          i18n.t("components.EVModelEditDetails.charts.cumulProbChart.chartLabels.0"),
          i18n.t("components.EVModelEditDetails.charts.cumulProbChart.chartLabels.1"),
        ],
      ];
      for (i = 0; i < power_percs.length; i++) {
        var sum = 0;
        for (var j = 0; j < charge_duration; j++) {
          var idx = i - j;
          if (idx < 0) {
            idx = power_percs.length + idx;
          }
          sum += power_percs[idx];
        }
        this.cumul_prob.push(Math.round(sum * 100) / 100);
        cumul_predicted.push([i, Math.round(sum * 100) / 100]);
      }
      this.cumul_prob_chart.data = cumul_predicted;
      var weekday_factor = this.ev_model.ChargePerWeekday;
      var weekend_factor = this.ev_model.ChargePerWeekendDay;
      var power_factor = this.ev_model.PowerFactor;
      var highpower_ratio = this.ev_model.HighPowerChargersRatio;

      var charger_avg_kva =
        (highpower_ratio * HIGH_POWER_EV_KV + (1 - highpower_ratio) * LOW_POWER_EV_KV) / power_factor;

      var charging_factor = isWeekend ? weekend_factor : weekday_factor;
      var bev_factor = this.ev_model.BEVRatio + (1 - this.ev_model.BEVRatio) * BEV_POWER_RATIO;

      var headrooms = this.ev_model_data["Headroom"];
      var ev_predicted = [
        [
          i18n.t("components.EVModelEditDetails.charts.evModelChart.chartLabels.0.title"),
          i18n.t("components.EVModelEditDetails.charts.evModelChart.chartLabels.1.title"),
          { role: "annotation" },
        ],
      ];

      var max_evs = 500;
      var max_ev_idx = -1;
      for (i = 0; i < headrooms.length; i++) {
        var max_allowable = Math.floor(headrooms[i] / charger_avg_kva);
        var confidence = 1 - this.ev_model.ConfidenceBinomial;
        var num_evs = this.calculate_binomial(
          confidence,
          (this.cumul_prob[i] / 100) * charging_factor * bev_factor,
          max_allowable
        );

        if (num_evs > 500) {
          num_evs = 500;
        }
        if (num_evs < 0) {
          num_evs = 0;
        }
        if (num_evs < max_evs) {
          max_evs = num_evs;
          max_ev_idx = i + 1;
        }
        ev_predicted.push([this.ev_model_data["HourOfDay"][i], num_evs, null]);
      }
      for (i = 0; i < ev_predicted.length; i++) {
        if (i == 0) {
          ev_predicted[i].push("MAX_EVS = " + max_evs);
        } else {
          ev_predicted[i].push(max_evs);
        }
      }
      if (max_ev_idx > 0) {
        ev_predicted[max_ev_idx][2] = `${i18n.t(
          "components.EVModelEditDetails.charts.evModelChart.chartLabels.2.title"
        )} = ${max_evs}`;
      }
      this.ev_max_predicted = max_evs;
      this.ev_model_chart.data = ev_predicted;
    },
  },
  computed: {
    high_power_chargers_ratio: {
      get: function () {
        return this.ev_model.HighPowerChargersRatio * 100;
      },
      set: function (v) {
        this.ev_model.HighPowerChargersRatio = parseFloat(v) / 100;
      },
    },
    bev_ratio: {
      get: function () {
        return this.ev_model.BEVRatio * 100;
      },
      set: function (v) {
        this.ev_model.BEVRatio = parseFloat(v) / 100;
      },
    },
    confidence_binomial: {
      get: function () {
        return this.ev_model.ConfidenceBinomial * 100;
      },
      set: function (v) {
        this.ev_model.ConfidenceBinomial = parseFloat(v) / 100;
      },
    },
    perc_new_car_buyer: {
      get: function () {
        return this.ev_model.PercentageNewCarBuyers * 100;
      },
      set: function (v) {
        this.ev_model.PercentageNewCarBuyers = parseFloat(v) / 100;
      },
    },
    power_load_chart_title: function () {
      return `${this.$t("components.EVModelEditDetails.charts.powerLoadDataOnly.title.1")} ${moment(
        this.load_profile_date
      ).format("ll")} ${this.$t("components.EVModelEditDetails.charts.powerLoadDataOnly.title.2")}`;
    },
    display_cols: function () {
      if (this.edit_mode) {
        return "8";
      } else {
        return "12";
      }
    },
    per_ev_power: function () {
      var power_factor = this.ev_model.PowerFactor;
      var highpower_ratio = this.ev_model.HighPowerChargersRatio;
      var retval = (highpower_ratio * HIGH_POWER_EV_KV + (1 - highpower_ratio) * LOW_POWER_EV_KV) / power_factor;

      return Math.round(retval * 100) / 100;
    },
    ev_calculated_sales: function () {
      var num_homes_without_ev = this.device_data["ConnectedMPRNs"];
      var purchase_prob = this.ev_model.PercentageNewCarBuyers;
      var output_data = [];
      output_data.push([
        this.$t("components.EVModelEditDetails.charts.totalNewEVCharge.chartLabels.0.title"),
        this.$t("components.EVModelEditDetails.charts.totalNewEVCharge.chartLabels.1.title"),
        { role: "annotation" },
        { role: "style" },
      ]);
      var cumul_calc_ev = 0;
      var has_annotation = false;
      var current_date = new Date();
      var base_year = current_date.getFullYear();
      var base_month = current_date.getMonth();
      var partial_year_factor = 1;
      for (var i = 1; i < this.PedictedEVSalesData.length; i++) {
        partial_year_factor = 1;
        if (base_year == this.PedictedEVSalesData[i][0]) {
          partial_year_factor = (12 - (base_month + 1)) / 12; //jan = 11/12 year remaining, dec= 0 /12 year remaining
        }
        var calc_ev = Math.round(
          num_homes_without_ev * purchase_prob * (this.PedictedEVSalesData[i][1] / 100) * partial_year_factor
        );
        cumul_calc_ev += calc_ev;
        num_homes_without_ev -= calc_ev;
        if (num_homes_without_ev < 0) {
          num_homes_without_ev = 0;
        }
        var annotation = null;
        var style_color = "primary";
        if (!has_annotation && cumul_calc_ev > this.ev_max_predicted) {
          (annotation = this.$t("components.EVModelEditDetails.charts.totalNewEVCharge.chartLabels.2.title")),
            (has_annotation = true);
          style_color = "#EF9A9A";
        }
        output_data.push([this.PedictedEVSalesData[i][0], cumul_calc_ev, annotation, style_color]);
      }
      return output_data;
    },
    power_load_data_only: function () {
      var output_data = [];
      var first_row = true;
      var ANNOTATION_COL = 3;
      this.ev_model_data = {
        HourOfDay: [],
        PowerUsed: [],
        Headroom: [],
        PluginStartPerc: [],
        PluginStartPercCommuter: [],
        PluginStartPercNonCommuter: [],
      };

      this.ev_base_data.forEach((element) => {
        if (first_row) {
          first_row = false;
          output_data.push([
            i18n.t("components.EVModelEditDetails.charts.powerLoadDataOnly.chartLabels.0.title"),
            i18n.t("components.EVModelEditDetails.charts.powerLoadDataOnly.chartLabels.1.title"),
            i18n.t("components.EVModelEditDetails.charts.powerLoadDataOnly.chartLabels.2.title"),
            { role: "annotation" },
            {
              role: "tooltip",
              type: "string",
              p: { html: true, role: "tooltip" },
            },
          ]);
          this.load_profile_date = element["LoadProfileDate"];
        }
        output_data.push([
          element["HourOfDay"],
          element["TotalPower"],
          element["TotalPower"],
          null,
          `${i18n.t("components.EVModelEditDetails.charts.powerLoadDataOnly.chartLabels.3.title")} (${
            element["TotalPower"]
          } ${i18n.t("common.measure.kVA")}, ${i18n.t(
            "components.EVModelEditDetails.charts.powerLoadDataOnly.chartLabels.2.title"
          )} = ${element["Headroom"]} ${i18n.t("common.measure.kVA")})`,
        ]);
        this.ev_model_data["HourOfDay"].push(element["HourOfDay"]);
        this.ev_model_data["PowerUsed"].push(element["TotalPower"]);
        this.ev_model_data["Headroom"].push(element["Headroom"]);
        this.ev_model_data["PluginStartPerc"].push(element["PluginStartPerc"]);
        this.ev_model_data["PluginStartPercCommuter"].push(element["PluginStartPercCommuter"]);
        this.ev_model_data["PluginStartPercNonCommuter"].push(element["PluginStartPercNonCommuter"]);
      });

      var i = 0;
      var max_load = 0;
      var idx = -1;
      for (i = 0; i < output_data.length; i++) {
        if (output_data[i][1] >= max_load) {
          max_load = output_data[i][1];
          idx = i;
        }
      }
      if (idx > 0) {
        var min_headroom = Math.round((this.device_data["PowerRating"] - max_load) * 100) / 100;
        output_data[idx][ANNOTATION_COL] = `Max Load (${max_load} kVa, Headroom = ${min_headroom} kVa)`;
      }
      return output_data;
    },
    inverse_highpower: function () {
      return Math.round((1 - this.ev_model.HighPowerChargersRatio) * 100);
    },
    inverse_bevratio: function () {
      return Math.round((1 - this.ev_model.BEVRatio) * 100);
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.opaque {
  opacity: 0.7;
}

.invalid_total {
  color: red;
}

.valid_total {
  color: black;
}
</style>
